import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "message", "preview"];

  fileSelected(event) {
    if (event.target.files.length === 0) {
      this.showPreview();
      this.clearMessage();
      return;
    }

    this.hidePreview();
    this.showMessage("保存するを押すとアップロード開始します");
  }

  submitting() {
    if (!this.hasSelectedFile()) {
      return;
    }

    this.hidePreview();
    this.showMessage("アップロード中です");
  }

  hasSelectedFile() {
    return this.hasInputTarget && this.inputTarget.files.length > 0;
  }

  hidePreview() {
    if (!this.hasPreviewTarget) {
      return;
    }

    this.previewTarget.hidden = true;
  }

  showPreview() {
    if (!this.hasPreviewTarget) {
      return;
    }

    this.previewTarget.hidden = false;
  }

  showMessage(message) {
    this.messageTarget.textContent = message;
    this.messageTarget.hidden = false;
  }

  clearMessage() {
    this.messageTarget.textContent = "";
    this.messageTarget.hidden = true;
  }
}
